/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Bulk domains request payload
 * @export
 * @interface BulkCustomerDomainsRequest
 */
export interface BulkCustomerDomainsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCustomerDomainsRequest
     */
    tenantIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCustomerDomainsRequest
     */
    customerIds?: Array<string>;
}

/**
 * Check if a given object implements the BulkCustomerDomainsRequest interface.
 */
export function instanceOfBulkCustomerDomainsRequest(value: object): value is BulkCustomerDomainsRequest {
    return true;
}

export function BulkCustomerDomainsRequestFromJSON(json: any): BulkCustomerDomainsRequest {
    return BulkCustomerDomainsRequestFromJSONTyped(json, false);
}

export function BulkCustomerDomainsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCustomerDomainsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantIds': json['tenantIds'] == null ? undefined : json['tenantIds'],
        'customerIds': json['customerIds'] == null ? undefined : json['customerIds'],
    };
}

export function BulkCustomerDomainsRequestToJSON(json: any): BulkCustomerDomainsRequest {
    return BulkCustomerDomainsRequestToJSONTyped(json, false);
}

export function BulkCustomerDomainsRequestToJSONTyped(value?: BulkCustomerDomainsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantIds': value['tenantIds'],
        'customerIds': value['customerIds'],
    };
}

